import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const Edit02Icon = (props?: SvgProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      stroke="#19191B"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <path
        d="M11 6.66671L8.33333 4.00004M0.666649 14.3334L2.92289 14.0827C3.19855 14.0521 3.33638 14.0367 3.46521 13.995C3.57951 13.958 3.68828 13.9058 3.78857 13.8396C3.90162 13.7651 3.99968 13.667 4.1958 13.4709L13 4.66671C13.7364 3.93033 13.7364 2.73642 13 2.00004C12.2636 1.26366 11.0697 1.26366 10.3333 2.00004L1.52913 10.8042C1.33301 11.0003 1.23495 11.0984 1.16041 11.2115C1.09427 11.3117 1.04199 11.4205 1.00499 11.5348C0.963286 11.6636 0.947972 11.8015 0.917343 12.0771L0.666649 14.3334Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
